import React from "react";
import CrudPage from "./CrudPage";
export default function AdminCertificates() {
  return <CrudPage title="Sertifikat" endpoint="certificates" testPrefix="cert" fields={[
    {key: "certificate_number", label: "Nomor Sertifikat"},
    {key: "holder_name", label: "Nama Pemegang"},
    {key: "scheme_code", label: "Kode Skema"},
    {key: "scheme_title", label: "Nama Skema"},
    {key: "status", label: "Status (Valid/Kadaluarsa/Dicabut)"},
    {key: "issue_date", label: "Tanggal Terbit (YYYY-MM-DD)"},
    {key: "valid_until", label: "Berlaku Hingga (YYYY-MM-DD)"},
  ]} />;
}
